import {isRetriableError} from '../utils/HttpUtils';
import {RootScope} from '../types/angular-types';
import * as Backoff from 'backo2';

/**
 * This function will return an Angular HTTP interceptor which will watch for certain HTTP request failures and
 * will retry those requests automatically
 *
 * @return object with request/response interceptors
 */
function RetryInterceptorFactory($q: ng.IQService, $injector, $rootScope: RootScope) {
    //This is the default jitter for production use
    var jitter = 0.5,
        maxRetryDurationGlobal = 10000;
    
    return {
        'setJitter': function(jitterParam) {
            jitter = jitterParam; //configurable jitter for testing
        },
        'setMaxRetryDuration': function(retryDuration) {
            maxRetryDurationGlobal = retryDuration; //configurable jitter for testing
        },
        'responseError': function(response) {
            const $http = $injector.get('$http');
            const requestConfig = response.config;
            if (isRetriableError(response) && !requestConfig.wdRetryRequest) {
                const deferred = $q.defer();
                var maxRetryDuration = maxRetryDurationGlobal;
                if (typeof requestConfig.timeout == 'number') {
                    maxRetryDuration = requestConfig.timeout;
                }

                //Set a flag on the config that we're initiating retries
                //This will stop any subsequent failures from re-entring this block of code
                requestConfig.wdRetryRequest = true;

                var backoffObj = new Backoff({
                    min: 500, // initial timeout in milliseconds
                    max: maxRetryDuration, // max timeout in milliseconds
                    jitter: jitter,
                    factor : 2 //exponential backoff
                });

                const retryCall = () => {
                    pendingTimeoutId = null;
                    $rootScope.$apply(function() {
                        $rootScope.metricServiceInstance.newCounterMetric('Ajax.HttpRetry');
                        $http(requestConfig).then(deferred.resolve, retryFailedCallback);
                    });
                };

                var pendingTimeoutId = null;
                const retryFailedCallback = (response) => {
                    //Called in $digest phase context.
                    const duration = backoffObj.duration()
                    if (duration >= maxRetryDuration || (response && !isRetriableError(response))) {
                        //Also check again before every retry failure if we can continue retrying
                        $rootScope.metricServiceInstance.newCounterMetric('Ajax.HttpRetryFailed');
                        deferred.reject(response);
                    } else {
                        pendingTimeoutId = setTimeout(retryCall, duration);
                    }
                };
                retryFailedCallback(null);
                $rootScope.metricServiceInstance.newCounterMetric('Ajax.HttpRetryStart');

                //Also honour any "timeout" promise that's set on the config
                if (requestConfig.timeout && angular.isFunction(requestConfig.timeout.then)) {
                    //then we're waiting on a promise resolution to cancel the retry
                    requestConfig.timeout.then(() => {
                        if (pendingTimeoutId) {
                            clearTimeout(pendingTimeoutId);
                        }
                    });
                }
                return deferred.promise;
            }
            return $q.reject(response);
        }
    };
}

angular.module('GorillaBoy.common')
.factory('RetryInterceptor', ['$q', '$injector', '$rootScope', RetryInterceptorFactory]);

//Don't push interceptor here, all interceptors are ordered in the app.module.ts config() callback function

export default RetryInterceptorFactory;

